import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TekstResourcePipe } from '../pipes/tekstresource.pipe';
import { Notification } from './notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  notifications$ = new Subject<Notification>();
  constructor(private tekstResourcePipe: TekstResourcePipe) {}

  error(message: string, title: string = null, correlationId: string = null) {
    const newMessage = correlationId
      ? `${message}
  <br/>
  ${this.tekstResourcePipe.transform('Fejl.Notifikation.Part2', { correlationId: correlationId })}`
      : message;
    this.notifications$.next({
      type: 'error',
      title: title,
      message: newMessage,
      hideDelay: 3600000, // show for 1 hour, that should be enough for the user to copy the correlation ID
      hideOnClick: true,
    });
  }

  warn(message: string, title: string = null, correlationId: string = null) {
    const newMessage = correlationId
      ? `${message}
<br/>
${this.tekstResourcePipe.transform('Fejl.Notifikation.Part2', { correlationId: correlationId })}`
      : message;
    this.notifications$.next({
      type: 'warning',
      title: title,
      message: newMessage,
    });
  }

  info(message: string, title: string = null) {
    this.notifications$.next({
      type: 'info',
      title: title,
      message: message,
      hideDelay: 5000,
    });
  }

  success(message: string = null, messageSanitized: string = null, title: string = null) {
    this.notifications$.next({
      type: 'success',
      title: title,
      message: message,
      messageSanitized: messageSanitized,
    });
  }

  show(notification: Notification) {
    this.notifications$.next(notification);
  }
}
